const btn = document.querySelectorAll('.loc-tabs');
const url = window.location.pathname.toLowerCase();
const newUrl = url.replace('/pages/', '').trim().replace(/[-_\s]+/g, '');

btn.forEach((ele) => {
    let span = ele.querySelector('.btn>span');
    if (span && newUrl === span.innerText.toLowerCase().replace(/[-_\s]+/g, '')) {
        ele.classList.add('highlight-button');
    } else{
        ele.classList.add('simple');
    }
});